module.exports = __webpack_public_path__ + "static/media/visa.328cfdb2.svg";